import { NamedLanguage, SupportedLanguageCode } from './i18n.types';

export const fallbackLng: SupportedLanguageCode = 'fr-FR';
export const supportedLngs: SupportedLanguageCode[] = ['fr-FR', 'ar-MA'];

export const languagesByCode: Record<SupportedLanguageCode, NamedLanguage> = {
  'fr-FR': { name: 'French', code: 'fr-FR' },
  'ar-MA': { name: 'العربية', code: 'ar-MA' },
};
